import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'substringMinus'
})
export class SubstringMinusPipe implements PipeTransform {

    constructor() { }

    /**
     * example : {{ prod?.productCode | substringMinus }}
     * return 'HPPM1'
     */
    transform(value: any, args?: any): any {
        if (value) {
            let subString = null;
            let val = '';
            subString = value.split('-');
            for (let i in subString) {
                val += subString[i];
            }
            return val == '' ? value : val;
        } else {
            return value;
        }
    }
}
